
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.263 2.52L1.01 10.773a.33.33 0 00-.086.151L.01 14.596a.326.326 0 00.315.403.32.32 0 00.078-.01l3.672-.914a.325.325 0 00.15-.086l8.255-8.253L9.263 2.52zM14.524 1.395l-.918-.92c-.614-.613-1.685-.613-2.298 0l-1.125 1.126 3.216 3.217 1.125-1.126c.307-.306.476-.715.476-1.149 0-.434-.17-.842-.476-1.148z","fill":"#E2E8F0"}})])
          )
        }
      }
    